import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BYS_GetDocumentContent_Request, BYS_GetDocumentContent_Response, CMY_GetDocumentContent_Request, CMY_GetDocumentContent_Response, EditTemplate, EditTemplateResponse, GetDefaultTemplate,
   GetTemplate, GetTemplateResponse, YIS_GetDocumentContent_Request, YIS_GetDocumentContent_Response } from '../../../models/dtos';
import { environment, UtilsService } from '@dabnet-kamu/libs/ui';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '@dabnet-kamu/libs/auth';
import { JsonApiClient } from '@servicestack/client';

@Injectable({
  providedIn: 'root'
})
export class DysService {
  client = JsonApiClient.create(environment.bysService);

  constructor(private _httpClient: HttpClient,
    private utilsService:UtilsService,
    // private authService: AuthService
  ) {
    // const accessToken = this.authService.loggedUser.access_token;
    // const headers = {
    //   'Content-Type': 'application/json',
    //   Authorization: 'Bearer ' + accessToken,
    // };
    // this.client.headers.append('Content-Type', headers['Content-Type']);
    // this.client.headers.append('Authorization', headers['Authorization']);
  }

  getDocument(kaynak: string,belgeKod: number,detayKod?: number,dysId?: number,updateContent?: boolean) {
    const request = new BYS_GetDocumentContent_Request({
      kaynak: kaynak,
      belgeKod: belgeKod,
      detayKod: detayKod,
      dysId: dysId,
      updateContent: updateContent
    })
    return this._httpClient.post<BYS_GetDocumentContent_Response>(`${environment.bysService}api/BYS_GetDocumentContent_Request`, request).pipe(
      map((res) => {
        return res as BYS_GetDocumentContent_Response;
      }))
  }


  getDocumentYis(kaynak: string,belgeKod: number,detayKod?: number,dysId?: number) {
    const request = new YIS_GetDocumentContent_Request({
      kaynak: kaynak,
      belgeKod: belgeKod,
      detayKod: detayKod,
      dysId: dysId
    })
    return this._httpClient.post<YIS_GetDocumentContent_Response>(`${environment.bysService}api/YIS_GetDocumentContent_Request`, request).pipe(
      map((res) => {
        return res as YIS_GetDocumentContent_Response;
      }))
  }

  getDocumentCmy(kaynak: string,belgeKod: number,detayKod?: number,dysId?: number) {
    const request = new CMY_GetDocumentContent_Request({
      kaynak: kaynak,
      belgeKod: belgeKod,
      detayKod: detayKod,
      dysId: dysId
    })
    return this._httpClient.post<CMY_GetDocumentContent_Response>(`${environment.bysService}api/CMY_GetDocumentContent_Request`, request).pipe(
      map((res) => {
        return res as CMY_GetDocumentContent_Response;
      }))
  }



  getTemplate(taslakKod: number) {
    const request = new GetTemplate({
      taslakKod: taslakKod
    })
    return this._httpClient.post<GetTemplateResponse>(`${environment.bysService}api/GetTemplate`, request).pipe(
      map((res) => {
        return res as GetTemplateResponse;
      }))
  }



  getDefaultTemplate() {
    const request = new GetDefaultTemplate({
    })
    return this._httpClient.post<GetTemplateResponse>(`${environment.bysService}api/GetDefaultTemplate`, request).pipe(
      map((res) => {
        return res as GetTemplateResponse;
      }))
  }

  editTemplate(request: EditTemplate) {
    return this._httpClient.post<EditTemplateResponse>(`${environment.bysService}api/EditTemplate`, request).pipe(
      map((res) => {
        return res as EditTemplateResponse;
      }))
  }



  downloadFile(content: any, mimeType: string, filename: string): void {
    let base64 =  content.startsWith('data:') ? content.split(',')[1] : content;
    const binaryContent = atob(base64);
    const length = binaryContent.length;
    const binaryArray = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      binaryArray[i] = binaryContent.charCodeAt(i);
    }
    const blob = new Blob([binaryArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  /**
   * DKM-5138 Cedric: indirme yanıtını dosyaya çevirmeden önce denetler. Hata yanıtı (404 boş gövde, ServiceStack JSON hatası)
   * ya da boş içerik dosya diye kaydedilmez; mesajıyla hata fırlatılır (önceden "Dosya İndirildi" deyip 0 KB dosya kaydediyordu).
   */
  private async indirmeBlobuAl(response: Response): Promise<Blob> {
    const tip = (response.headers.get('content-type') || '').toLowerCase();
    if (!response.ok) {
      let metin = '';
      try { metin = await response.text(); } catch { metin = ''; }
      throw new Error(this.indirmeHataMesaji(metin) || `Belge bulunamadı (HTTP ${response.status}${response.statusText ? ' ' + response.statusText : ''})`);
    }
    if (tip.includes('application/json')) {
      const metin = await response.text();
      const hata = this.indirmeHataMesaji(metin);
      if (hata) throw new Error(hata);
      return new Blob([metin], { type: tip });
    }
    const blob = await response.blob();
    if (blob.size === 0) throw new Error('İndirilen dosya boş (0 KB); belge içeriği sunucuda bulunamadı.');
    // Servis hatası .zip/.pdf adresinde Content-Type'sız JSON dönebiliyor (canlıda görüldü: "38467.zip" = JSON hata metni)
    if (blob.size < 65536) {
      const bas = await blob.slice(0, 1).text();
      if (bas === '{') {
        const hata = this.indirmeHataMesaji(await blob.text());
        if (hata) throw new Error(hata);
      }
    }
    return blob;
  }

  private indirmeHataMesaji(metin: string): string {
    if (!metin) return '';
    try {
      const j = JSON.parse(metin);
      if (j?.result === false || j?.Result === false || j?.responseStatus || j?.ResponseStatus)
        return j.errorMessage || j.ErrorMessage || j.responseStatus?.message || j.ResponseStatus?.Message || 'Dosya indirilemedi';
      return '';
    } catch {
      return metin.length < 300 ? metin : '';
    }
  }

  async downloadSablonDoc(dysId: string,fileName?:string,isEkBelge?:boolean,belgeEkKod?:number) {
    var url = ''
    if(isEkBelge && dysId?.startsWith('F@')){

      // DKM-5138 Cedric: eski hâli — dosya adında / # ? varsa rota bozuluyordu
      // url = `${environment.bysService}Bys/DownloadBelgeEk/${belgeEkKod}/${fileName}`;
      url = `${environment.bysService}Bys/DownloadBelgeEk/${belgeEkKod}/${encodeURIComponent(fileName || 'ek')}`;
    }
    else if(fileName?.length >0){

      url = `${environment.bysService}Bys/DownloadFile/${dysId}/${fileName}`;
    }else{
      url = `${environment.bysService}Bys/Download/${dysId}`;
    }

    await fetch(url, {
      method: 'GET'
    })
        // DKM-5138 Cedric: eski hâli — hata yanıtı (404 boş gövde / JSON hata) dosya diye kaydediliyordu (0 KB, açılmayan PDF/zip)
        // .then(response => response.blob())
        .then(response => this.indirmeBlobuAl(response))
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName || 'downloaded-file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
            this.utilsService.showSuccess('Dosya İndirildi')
        })
        .catch((error) => {
          this.utilsService.showError(error,'Dosya İndirilemedi')
          return false;
        }
      );
  }


  async downloadGasBelgeWithBelgeKod(belgeKod: number,fileName?:string) {
    var url = ''
      // DKM-5138 Cedric: eski hâli — servisteki rota /GAS/DownloadBelge/{BelgeKod}/{FileName}; bu adres 404 (boş gövde) dönüyor, 0 KB dosya iniyordu
      // url = `${environment.bysService}Bys/Gas_DownloadBelge/${belgeKod}/${fileName}`;
      url = `${environment.bysService}GAS/DownloadBelge/${belgeKod}/${encodeURIComponent(fileName || 'belge')}`;

    await fetch(url, {
      method: 'GET'
    })
        // DKM-5138 Cedric: eski hâli — hata yanıtı (404 boş gövde / JSON hata) dosya diye kaydediliyordu (0 KB, açılmayan PDF/zip)
        // .then(response => response.blob())
        .then(response => this.indirmeBlobuAl(response))
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName || 'downloaded-file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
            this.utilsService.showSuccess('Dosya İndirildi')
        })
        .catch((error) => {
          this.utilsService.showError(error,'Dosya İndirilemedi')
          return false;
        }
      );
  }


  async downloadGasToplu(dosyaKod: number,belgeTuruKod:number) {
    var url = '';
    var fileName = belgeTuruKod===-1?`${dosyaKod}.zip`:`${dosyaKod}_${belgeTuruKod}.zip`;
    url = `${environment.bysService}GAS/DosyaIndirZip/${dosyaKod}_${belgeTuruKod}.zip?dosyaKod=${dosyaKod}&belgeTuruKod=${belgeTuruKod}`;
    await this.zipIndir(url, fileName);
  }

  /** Dosyadaki belgeleri SDP koduna göre (bu kod ve altındaki kodlar) zip olarak indirir. */
  async downloadGasTopluSdp(dosyaKod: number, dosyaPlanKod: string) {
    const fileName = `${dosyaKod}_${dosyaPlanKod}.zip`;
    const url = `${environment.bysService}GAS/DosyaIndirZip/${fileName}?dosyaKod=${dosyaKod}&dosyaPlanKod=${encodeURIComponent(dosyaPlanKod)}`;
    await this.zipIndir(url, fileName);
  }

  private async zipIndir(url: string, fileName: string) {
    await fetch(url, {
      method: 'GET'
    })
        // DKM-5138 Cedric: eski hâli — hata yanıtı (404 boş gövde / JSON hata) dosya diye kaydediliyordu (0 KB, açılmayan PDF/zip)
        // .then(response => response.blob())
        .then(response => this.indirmeBlobuAl(response))
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName || 'downloaded-file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
            this.utilsService.showSuccess('Dosya İndirildi')
        })
        .catch((error) => {
          this.utilsService.showError(error,'Dosya İndirilemedi')
          return false;
        }
      );
  }

  // downloadSablonDoc(dysId: string): Observable<boolean> {
  //   const url = `${environment.bysService}Bys/Download/${dysId}`;
  //   return this._httpClient.get(url, { responseType: 'blob', observe: 'response' }).pipe(
  //     map((response) => {
  //       const blob = response.body!;

  //       // 1. Content-Disposition başlığından dosya adını alma
  //       let fileName = `dosya_${dysId}`;
  //       const contentDisposition = response.headers.get('Content-Disposition');
  //       if (contentDisposition) {
  //         const match = contentDisposition.match(/filename="?([^"]+)"?/);
  //         if (match) {
  //           fileName = match[1];
  //         }
  //       }

  //       // 2. MIME türüne göre dosya uzantısı çıkarma
  //       if (!fileName.includes('.')) {
  //         const mimeType = blob.type;
  //         let fileExtension = 'bin'; // Varsayılan uzantı

  //         // Görüntü dosyalarını kontrol etme
  //         if (mimeType.startsWith('image/')) {
  //           const parts = mimeType.split('/');
  //           fileExtension = parts[1] ? parts[1] : 'bin';
  //         }
  //         // Diğer türlerde varsayılan uzantı belirleme
  //         else{
  //           const match = mimeType.match(/[^/]+$/);
  //           fileExtension = match ? match[0] : 'bin';
  //         }
  //         console.log(mimeType)
  //         console.log(fileExtension)


  //         // if (mimeType.endsWith('pdf')) {
  //         //   fileExtension = 'pdf';
  //         // }
  //         // // Diğer türlerde varsayılan uzantı belirleme
  //         // else if (mimeType.endsWith('jpeg')) {
  //         //   fileExtension = 'jpeg';
  //         // }
  //         // // Diğer türlerde varsayılan uzantı belirleme
  //         // else if (mimeType.endsWith('png')) {
  //         //   fileExtension = 'png';
  //         // }
  //         // // Diğer türlerde varsayılan uzantı belirleme
  //         // else if (mimeType.endsWith('jpg')) {
  //         //   fileExtension = 'jpg';
  //         // }
  //         // else {
  //         //   fileExtension = 'bin'; // Bilinmeyen MIME türleri için
  //         // }

  //         // Dosya adına uzantıyı ekle
  //         fileName += `.${fileExtension}`;
  //       }

  //       // 3. Dosyayı indirme
  //       const downloadUrl = window.URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = downloadUrl;
  //       link.download = fileName;
  //       link.click();
  //       window.URL.revokeObjectURL(downloadUrl);

  //       return true;
  //     }),
  //     catchError((err) => {
  //       console.error('Dosya indirme hatası:', err);
  //       return of(false);
  //     })
  //   );
  // }


}
